export enum DebugLogCategory {
  Request = 'request',
  Response = 'response',
  Error = 'error',
  Event = 'event',
  Navigation = 'nav',
  Other = 'other',
}

export interface IDebugLogCategoryInfo {
  category: DebugLogCategory;
  label: string;
  badge: string;
}

export const DEBUG_LOG_CATEGORIES: IDebugLogCategoryInfo[] = [
  { category: DebugLogCategory.Request, label: 'Requests', badge: 'REQ' },
  { category: DebugLogCategory.Response, label: 'Responses', badge: 'RES' },
  { category: DebugLogCategory.Error, label: 'Errors', badge: 'ERR' },
  { category: DebugLogCategory.Event, label: 'Events', badge: 'EVT' },
  { category: DebugLogCategory.Navigation, label: 'Navigation', badge: 'NAV' },
  { category: DebugLogCategory.Other, label: 'Other', badge: 'LOG' },
];



// WEBPACK FOOTER //
// ./src/model/types/debug-log-type.ts